import React from 'react'

import { bemJoin } from 'bem-join'

import { useIntl } from '@app/intl/Intl'
import { Button } from '@app/lib/inputs/Button/Button'

import './CourtCaseStatusButton.scss'

export type CourtCaseStatusButtonProps = {
  isOngoing: boolean | null | undefined
}

export const CourtCaseStatusButton = ({ isOngoing }: CourtCaseStatusButtonProps) => {
  const { formatMessage } = useIntl()
  const b = bemJoin('court-case-status')

  if (typeof isOngoing !== 'boolean') {
    return null
  }

  if (isOngoing) {
    return (
      <Button className={b('button')} variant='solid' color='danger'>
        {formatMessage({ id: 'CourtCases.Reopen.Open' })}
      </Button>
    )
  }

  return (
    <Button className={b('button')} variant='solid' color='success'>
      {formatMessage({ id: 'CourtCases.Reopen.Closed' })}
    </Button>
  )
}
